import { COU_CheckValidation } from "@/utils/co_util"

// 1688晓风分销授权应用的appKey
export const Service_Tb1688FxAppKey = '6887888'

// 显示1688授权提示
export function Service_ShowAliAuthModal(link, msg) {
	return COU_CheckValidation(link, {
		content1:msg || '当前需要先授权【1688】，才能继续使用【1688】铺货等功能',
		content2:'如已确认操作完成，请点击【确定】按钮',
		okText1:`去${msg?.includes('免费') ? '订购' : '授权'}`
	})
}